export default "__VITE_ASSET__gVoq6xGG__"